module.exports = __webpack_public_path__ + "img/Path 5 Copy@3x.38424baa.png";